'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _grid = require('../grid');

exports["default"] = _grid.Row;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.8.1@antd/lib/row/index.js
// module id = 5
// module chunks = 0